// extracted by mini-css-extract-plugin
export default {"loading":"UiPill_loading_eUiTn","statsBubbleLoading":"UiPill_statsBubbleLoading__8GIN"};